import React from 'react';
import { Building2, MapPin, Users, Briefcase, ClipboardList, DollarSign } from 'lucide-react';
import ConfigCard from '../ConfigCard';

const BasicConfigTab = ({ configData, cardProps }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Departments" icon={Building2}
        items={configData.departments}
        category="departments"
        fields={['head_of_department_name']}
      />
      <ConfigCard {...cardProps} title="Locations" icon={MapPin}
        items={configData.locations}
        category="locations"
        fields={['timezone']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Classifications" icon={Users}
        items={configData.classifications}
        category="classifications"
        fields={['description']}
      />
      <ConfigCard {...cardProps} title="Designations" icon={Briefcase}
        items={configData.designations}
        category="designations"
        fields={['description']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Employment Types" icon={ClipboardList}
        items={configData.employmentTypes}
        category="employmentTypes"
        fields={['description']}
      />
      <ConfigCard {...cardProps} title="Pay Grades" icon={DollarSign}
        items={configData.payGrades}
        category="payGrades"
        fields={['salary_min', 'salary_max']}
      />
    </div>
  </div>
);

export default BasicConfigTab;
